import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import useCreateMesssagePreview from 'App/hooks/useCreateMesssagePreview';
import useFetchMobileUrlQuery from 'App/hooks/useFetchMobileUrlQuery';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import FlexCenter from 'App/components/styles/FlexCenter';
import * as R from 'ramda';
import ErrorMessage from 'App/components/errors/ErrorMessage';
import SendButton from './SendButton';

const propTypes = {
    onHide: PropTypes.func.isRequired,
    patientName: PropTypes.string.isRequired,
    activityName: PropTypes.string.isRequired,
    patientId: PropTypes.string.isRequired,
    activityId: PropTypes.string.isRequired,
};

const defaultProps = {};

function messageTemplate(mobileUrl = '') {
    return ['Please complete the questionnaire online at ', `${mobileUrl}.`].join('');
}

function SendMobileLinkModal({ onHide, patientName, activityName, patientId, activityId }) {
    const fetchMobileUrlQuery = useFetchMobileUrlQuery(patientId, activityId);

    const preview = useCreateMesssagePreview(messageTemplate(fetchMobileUrlQuery.data?.mobileLink));

    return (
        <Modal onHide={onHide} backdrop="static" show>
            <Modal.Header onHide={onHide}>
                <h4>Send Mobile Link</h4>
            </Modal.Header>
            {R.cond([
                [
                    R.equals('success'),
                    () => (
                        <Modal.Body>
                            <p>
                                This action will send a link to
                                <strong>{` ${patientName} `}</strong>
                                for their <strong>{` ${activityName} `}</strong>
                            </p>

                            <br />

                            <p>
                                <strong>This will send immediately.</strong>
                            </p>
                        </Modal.Body>
                    ),
                ],
                [
                    R.equals('loading'),
                    () => (
                        <FlexCenter>
                            <TherigyLoadingSpinner />
                        </FlexCenter>
                    ),
                ],
                [R.equals('error'), () => <ErrorMessage>An error occurred getting the URL.</ErrorMessage>],
            ])(fetchMobileUrlQuery.status)}

            <Modal.Footer>
                <FormButtonGroup>
                    <Button variant="outline-secondary" type="button" onClick={onHide}>
                        Close
                    </Button>
                    <SendButton
                        message={preview.completeMessage}
                        isDisabled={['loading', 'error'].includes(fetchMobileUrlQuery.status)}
                        patientId={patientId}
                        activityId={activityId}
                    />
                </FormButtonGroup>
            </Modal.Footer>
        </Modal>
    );
}

SendMobileLinkModal.propTypes = propTypes;
SendMobileLinkModal.defaultProps = defaultProps;

export default SendMobileLinkModal;
